import { Cell, flexRender } from "@tanstack/react-table";
import { twMerge } from "tailwind-merge";

import { DataTableDataType, ExpandedColumnDef } from "..";
import getCommonPinningStyles from "../utils/getCommonPinningStyles";

type TableCellProps = {
  cell: Cell<any, DataTableDataType>;
  isSelected: boolean;
};

export const TableCell: React.FC<TableCellProps> = ({ cell, isSelected }) => {
  const { rightAlign, isClickable } = cell.column
    .columnDef as ExpandedColumnDef;

  const isActions = cell.column.id === "actions";
  const isPinned = cell.column.getIsPinned();

  return (
    <td
      key={cell.id}
      className={twMerge(
        "text-ellipsis whitespace-nowrap",
        !isClickable && "overflow-hidden px-2.5 py-2.5",
        rightAlign && "justify-end pr-8 text-end",
        isPinned === "right" && "bg-grey1! font-medium",
        isSelected && "bg-selected-color!",
        "group-hover:bg-hover-color!",
        isActions && "overflow-visible",
      )}
      style={getCommonPinningStyles(cell.column)}
    >
      {flexRender(cell.column.columnDef.cell, cell.getContext())}
    </td>
  );
};
